<script setup lang="ts">
import type { MappedFormField } from '~/models/Content/Form'
import { computed } from 'vue'

const {
  field,
  showLabel,
  showPlaceholder,
  showDescription,
  disableFields,
} = defineProps<{
  field: MappedFormField
  showLabel: boolean
  showPlaceholder: boolean
  showDescription: boolean
  disableFields: boolean
}>()

const model = defineModel<string>()

const label = computed(() => showLabel && field.name ? field.name : '')
const description = computed(() => showDescription && field.help ? field.help : '')
const placeholder = computed(() => showPlaceholder && field.placeholder ? field.placeholder : '')
</script>

<template>
  <div class="flex flex-col text-lg">
    <label
      v-if="label"
      :for="`input-${field.id}`"
      class="animate-fade-in-right text-xl font-bold"
      :class="{ 'mb-1': !description }"
      v-text="label"
    />
    <small
      v-if="description"
      :id="`description-${field.id}`"
      class="mb-2 animate-fade-in-right text-base font-normal"
      v-text="description"
    />
    <input
      v-if="field.identifier === 'single_line'"
      :id="`input-${field.id}`"
      v-model="model"
      :placeholder
      type="text"
      :aria-describedby="`description-${field.id}`"
      class="w-full rounded-md border-2 border-[--theme-50] px-4 py-3 ring-[--theme-50] transition placeholder:text-gray-40 hover:ring-1 focus-visible:ring-2 disabled:cursor-not-allowed disabled:bg-white"
      :disabled="disableFields"
    >
    <textarea
      v-else-if="field.identifier === 'multi_line'"
      :id="`input-${field.id}`"
      v-model="model"
      :placeholder
      :aria-describedby="`description-${field.id}`"
      class="w-full rounded-md border-2 border-[--theme-50] px-4 py-3 ring-[--theme-50] transition placeholder:text-gray-40 hover:ring-1 focus-visible:ring-2 disabled:cursor-not-allowed disabled:bg-white"
      :disabled="disableFields"
    />
  </div>
</template>

<style scoped>
textarea {
  field-sizing: content;
}
</style>
